import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output
} from '@angular/core';
import { WorkVehicleWarehouse } from '../../../../core/services/vehicles.service';
import { WarehouseService } from '../../../../core/services/warehouse.service';
import { TelemetryService, VehicleStatuses } from 'src/app/core/services/telemetry.service';
import { RouteDriverUpdateModalComponent } from '../route-driver-update-modal/route-driver-update-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PERMISSIONS, PermissionService } from 'src/app/core/services/permission.service';

@Component({
  selector: '[app-route-history-table-row-ride]',
  templateUrl: './route-history-table-row-ride.component.html',
  styleUrls: ['./route-history-table-row-ride.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouteHistoryTableRowRideComponent implements AfterViewInit {
  @Input() data: WorkVehicleWarehouse;
  @HostBinding('class.is-selected')
  @Input() isSelected = false;
  @Input() isDriver = false;
  @Input() fuelDimmension = 'DISTANCE';
  @Output() rideTypeChange = new EventEmitter();
  trElementRef!: HTMLElement;
  @HostBinding('class.is-override') get isOverride() {
    return this.data && this.data.RIDE_IS_OVERRIDE && this.data.RIDE_IS_OVERRIDE[0].v;
  }

  constructor(protected warehouseService: WarehouseService, 
    protected elementRef: ElementRef,
    protected cd: ChangeDetectorRef, 
    protected telemetryService: TelemetryService, 
    protected modal: NgbModal,
    public permissionService: PermissionService) {

  }
  ngAfterViewInit(): void {
    this.trElementRef = this.elementRef.nativeElement;
    this.cd.detectChanges();
  }

  get rideStatus() {
    return this.warehouseService.rideStatus(this.data);
  }

  changeRideStatus($event: MouseEvent) {
    $event.preventDefault();
    this.telemetryService.updateRide(this.data.ID[0].v, {
      ride: {
        isWork: this.getNewIsWorkStatus()
      }
    }).subscribe(res => {
    this.rideTypeChange.emit();
    });
  }

  getNewIsWorkStatus() {
    const status = this.rideStatus;
    return status !== VehicleStatuses.BUSINESS_RIDE;
  }

  getNewIsWorkStatusLabel() {
    return this.getNewIsWorkStatus() ? 'CHANGE_TO_BUSINESS' : 'CHANGE_TO_PRIVATE';
  }

  stopPropagation($event: MouseEvent) {
    $event.stopPropagation();
  }

  get odometerRangeLabel() {
    if (!this.data || !this.data.RIDE_STARTTOTALDISTANCE || !this.data.PARK_STARTTOTALDISTANCE) {
      return '';
    }
    const startOdo: string = this.data.RIDE_STARTTOTALDISTANCE[0].v ?
      `${this.formatDistance(this.data.RIDE_STARTTOTALDISTANCE[0].v)} km` :
      '...';
    const endtOdo: string = this.data.PARK_STARTTOTALDISTANCE[0].v ?
      `${this.formatDistance(this.data.PARK_STARTTOTALDISTANCE[0].v)} km` :
      '...';
    return `${startOdo} - ${endtOdo}`;
  }

  formatDistance(distance: number): string {
    return distance ?
      distance.toLocaleString('fr-FR', { minimumFractionDigits: 0 }) :
      '0';
  }

  showUpdateDriverModal($event: MouseEvent) {
      if (!this.permissionService.hasPermission(PERMISSIONS.VEHICLE_UPDATE)) {
        return;
      }
      if (!this.data.PARK_ENDDATE[0].v) {
        return;
      }
      $event.stopPropagation();
      console.log('this.Data', this.data);
      const vehicleId: string = this.data.VEHICLE[0].v.id;
      const rideStartDate: string = this.data.RIDE_STARTDATE[0].v;
      const parkStartDate: string = this.data.PARK_STARTDATE[0].v;
      const parkEndDate: string = this.data.PARK_ENDDATE[0].v;
      const driverId: string = this.data.DRIVER[0].v ? this.data.DRIVER[0].v.id : null;
      const modal = this.modal.open(RouteDriverUpdateModalComponent);
      modal.componentInstance.vehicleId = vehicleId;
      modal.componentInstance.rideStartEventDate = rideStartDate;
      modal.componentInstance.parkStartEventDate = parkStartDate;
      modal.componentInstance.parkEndEventDate = parkEndDate;
      modal.componentInstance.driverId = driverId;
      modal.result.then(res => {}, () => {});
    }
}
